import axios from 'axios';

const helpFirebaseApi = 'https://legaleyse.firebaseio.com/help.json';

export const getHelp = () => axios.get(helpFirebaseApi);
